import { setList } from './notifications'

export const pushNotification = (notif) => (dispatch, getState) => {
  const { notifications: { list } } = getState()

  let l = list.length === 5 ? list.slice(1, 5) : [...list]
  l.push(notif)

  dispatch(setList(l))
}

export const removeNotification = (id) => (dispatch, getState) => {
  const { notifications: { list } } = getState()
  const l = [ ...list ]

  let index = 0
  list.forEach((item, i) => {
    if (item.id === id) index = i
  })

  l.splice(index, 1)

  dispatch(setList(l))
}
